import { api } from '@api/client'
import { cached, makeKey, TWELVE_HOURS_MS } from '@cache/requestCache'
import { buildComponentUrl } from './component.urls'

export function getComponents ({
  companyId = null,
  siteId = null,
  assetId = null
}) {
  const url = buildComponentUrl({ companyId, siteId, assetId })
  const key = makeKey(url, {})

  return cached(
    key,
    async () => {
      const response = await api.get(url)
      return response.data
    },
    TWELVE_HOURS_MS
  )
}
